document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.top-header-inner.swiper');
  if (!sliders.length || typeof Swiper === 'undefined') return;

  sliders.forEach(function (sliderEl) {
    if (sliderEl.dataset.initialized === 'true') return;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    var swiper = new Swiper(sliderEl, {
      slidesPerView: 2,
      breakpoints: {
        750: {
          slidesPerView: 2,
          autoplay: false,
          loop: false
        },
        1025: {
          slidesPerView: 4,
          autoplay: false,
          loop: false
        }
      },
      watchOverflow: true,
      loop: isMobile,
      autoplay: isMobile ? { delay: 3000, disableOnInteraction: false } : false,
      a11y: true
    });

    // Store instance reference for potential future use
    sliderEl.swiperInstance = swiper;
    sliderEl.dataset.initialized = 'true';
  });
});

